import React, { Component } from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import ReactDataGrid from 'react-data-grid';
import { UI_HEIGHT } from '../Common/constants';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, Button, Table, Breadcrumb, ButtonToolbar } from 'react-bootstrap';
import { Link } from 'react-router';
import Spinner from '../../components/Widgets/spinner';
import { Translate, Localize } from 'react-redux-i18n';

class PurchaseTemplateList extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.twoLineButton,

            rows: [],
            selectedRows: null,
            filters: {},
            sortColumn: null,
            sortDirection: null,
            purchaseTemplateDetail: {
              rows: [],
              filters: {},
              sortColumn: null,
              sortDirection: null,
            }
        };
        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.props.fetchPurchaseTemplates();
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    // Once products are ready, reset state.

    componentWillReceiveProps(nextProps) {
        if (nextProps.purchaseTemplates && nextProps.purchaseTemplates != this.props.purchaseTemplates) {
            this.setState({
                rows: nextProps.purchaseTemplates
            });
        }

        if (nextProps.purchaseTemplateList && nextProps.purchaseTemplateList != this.props.purchaseTemplateList) {
            var purchaseTemplateDetail = {...this.state.purchaseTemplateDetail, rows: nextProps.purchaseTemplateList };
            this.setState({purchaseTemplateDetail});
        }
    }

    handleResize(e) {
        this.setState({tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton});
    }

    // Set product being selected to be currentProduct and navigate user to the edit page

    setCurrentPurchaseTemplate(e) {
        e.preventDefault();
        const currentPurchaseTemplate = this.state.selectedRows[0];
        this.props.resetCurrentPurchaseTemplate();
        this.props.selectPurchaseTemplate(currentPurchaseTemplate);
        this.context.router.push('/purchaseTemplate/'+currentPurchaseTemplate.PurchaseTemplate_id);
    }

    deleteCurrentPurchaseTemplate(e) {
        e.preventDefault();
        const currentPurchaseTemplate = this.state.selectedRows[0];
        this.props.resetCurrentPurchaseTemplate();
        this.props.selectPurchaseTemplate(currentPurchaseTemplate);
        this.props.deletePurchaseTemplate(currentPurchaseTemplate.PurchaseTemplate_id);
    }

    clickNew(e) {
        e.preventDefault();
        this.props.resetCurrentPurchaseTemplate();
        this.context.router.push('/purchaseTemplate/new')
    }

    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderTable() {
        if (this.props.isLoading && !this.props.error) return <Spinner/>
        else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            let tableHeight = (window.innerHeight < 900) ? 345 : 345;

            const getRows = () => {
                return Data.Selectors.getRows(this.state);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            const onRowClick = (rowIdx, row) => {
              if(rowIdx != -1) {
                let rows = getRows();
                rows.map(row => {
                  row.isSelected = false;
                });
                rows[rowIdx].isSelected = true;
                this.setState({rows, selectedRows: [rows[rowIdx]]})
                this.props.fetchPurchaseTemplateList(row.PurchaseTemplate_id);
              }
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState(state);
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                this.setState({ filters: newFilters });
            }

            // Handle the row select function

            const onRowSelect = rows => {
                this.setState({ selectedRows: rows });
            }

            //Custom Formatter component

            const DateFormatter = React.createClass({
                render() {
                    if (this.props.value) {
                      let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                      let date = new Date(this.props.value)
                      let index = dateMap.indexOf(date.toString().slice(4,3));
                      let localDate = index + date.toString().slice(8, 6);
                      return <span>{date.toString().slice(4, 15)}</span>;;
                    }
                    else return <span className="label label-danger">-</span>;
                }
            });

            const VendorNameFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            const VendorNumFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            const onRowsSelected = (rows) => {
                let newRows = getRows();
                let selectedRows = [newRows[rows[0].rowIdx]];
                newRows.map(r => {
                  r.isSelected = false;
                });
                rows.map(r => {
                  newRows[r.rowIdx].isSelected = true;
                });
                this.setState({ rows: newRows, selectedRows: selectedRows });
            }
            const onRowsDeselected = (rows) => {
                let rowIndexes = rows.map(r => r.rowIdx);
                let newRows = [...this.state.rows];
                rows.map (r => {
                  newRows[r.rowIdx].isSelected = false;
                });
                this.setState({ rows: newRows, selectedRows: [] });
            }

            const onClearFilters = () => {
                     //all filters removed
                     this.setState({ filters: {} });
            }

            // Column difinition

            const columns = [
                {
                    key: 'Name',
                    name: <Translate value="name" />,
                    resizable: true,
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'Vendor_id__Name',
                    name: <Translate value="vendor_name" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                    formatter: VendorNameFormatter
                },
                {
                    key: 'CreateTime',
                    name: <Translate value="created_time" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                    formatter: DateFormatter
                }
            ]

            return (
                <Row><Col sm={ 12 }><div id="PurchaseTemplateList-dataGrid1">
                    <ReactDataGrid
                        rowKey='PurchaseTemplate_id'
                        onGridSort={handleGridSort}
                        onClearFilters={onClearFilters}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowHeight={25}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        minHeight={tableHeight}
                        enableRowSelect='single'
                        onRowUpdated={this.handleRowUpdated}
                        rowSelection={{
                          showCheckbox: true,
                          onRowsSelected: onRowsSelected,
                          onRowsDeselected: onRowsDeselected,
                          selectBy: {
                            isSelectedKey: 'isSelected'
                          }
                        }}
                        onRowClick={onRowClick}
                         />
                </div></Col></Row>
            )
        }
    }

    renderProductsTable() {
        if (this.props.purchaseTemplateListIsLoading && !this.props.purchaseTemplateListError) return <Spinner/>
        else if (this.props.purchaseTemplateListError) return (
          <ContentWrapper>
            <div className="alert alert-danger">{JSON.stringify(this.props.purchaseTemplateListError)}
            </div>
          </ContentWrapper>)
        else {
            // Parameters of the react-data-grid

            let tableHeight = (window.innerHeight < 900) ? 225 : 225;

            const getRows = () => {
                return Data.Selectors.getRows(this.state.purchaseTemplateDetail);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var state = Object.assign({}, this.state.purchaseTemplateDetail, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState({purchaseTemplateDetail: state});
            }

            const onClearFilters = () => {
                     //all filters removed
                     let purchaseTemplateDetail = {...this.state.purchaseTemplateDetail, filters: {}};
                     this.setState({ purchaseTemplateDetail });
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.purchaseTemplateDetail.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                var purchaseTemplateDetail = {...this.state.purchaseTemplateDetail, filters: newFilters};
                this.setState({ purchaseTemplateDetail });
            }



            //Custom Formatter component

            const DateFormatter = React.createClass({
                render() {
                    if (this.props.value) {
                      let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                      let date = new Date(this.props.value)
                      let index = dateMap.indexOf(date.toString().slice(4,3));
                      let localDate = index + date.toString().slice(8, 6);
                      return <span>{date.toString().slice(4, 15)}</span>;;
                    }
                    else return <span className="label label-danger">-</span>;
                }
            });


            const VendorNameFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.Name}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            const VendorNumFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            // Column definition

            const columns = [
                {
                    key: 'Product_id__ProductNum',
                    name: <Translate value="product_num" />,
                    resizable: true,
                    sortable: true,
                    width: 100,
                },
                {
                    key: 'Product_id__Name',
                    name: <Translate value="product_name" />,
                    resizable: true,
                    sortable: true,
                },
                {
                    key: 'Product_id__Description',
                    name: <Translate value="description" />,
                    resizable: true,
                    sortable: true,
                },
                {
                    key: 'Quantity',
                    name: <Translate value="qty" />,
                    resizable: true,
                    width: 40,
                    sortable: true,
                },
                {
                    key: 'PackageType',
                    name: <Translate value="pkg_type" />,
                    resizable: true,
                    width: 80,
                    sortable: true,
                },
                {
                    key: 'FOBUnitPrice',
                    name: <Translate value="unit_dollarsign" />,
                    resizable: true,
                    width: 70,
                    sortable: true,
                },
                {
                    key: 'TotalPrice',
                    name: <Translate value="total_dollarsign" />,
                    resizable: true,
                    width: 80,
                    sortable: true,
                }
            ]

            // React Table Purchase Order Details
            return (
              <Row>
                <Col xs={ 12 }>
                  <div className="recat-customizer" id="PurchaseTemplateList-dataGrid2">
                    <ReactDataGrid
                        rowKey='SalesOrder_id' //Should be PO ID???
                        onGridSort={handleGridSort}
                        onAddFilter={handleFilterChange}
                        onClearFilters={onClearFilters}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        rowHeight={25}
                        minHeight={tableHeight}
                        onRowUpdated={this.handleRowUpdated}
                      />
                  </div>
                </Col>
              </Row>
            )
        }
    }

    checkPermission(permission) {
        return false;
    }

    render() {
      let height = (this.state.tableHeight*2/3 + 70).toString();
      let tableCollapseFix = {height: height}
      let detailsTableHeight = (this.state.tableHeight/2.5+45).toString();
      let detailsTableCollapseFix = {height: detailsTableHeight}
        return (
            <ContentWrapper>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Translate value="purchase_management" />
                </Breadcrumb.Item>
                <Breadcrumb.Item active="true">
                  <Translate value="purchase_template" />
                </Breadcrumb.Item>
              </Breadcrumb>
            <Grid id="purchase-template-list">
                <h1><Translate value="purchase_template_full_table" /></h1>
              <Row>
                <Col xs={ 12 }>
                  <Panel className="position-relative table-collapse-fix">
                    <ButtonToolbar className="table-buttons">
                      <Button
                          bsStyle="success"
                          type="submit"
                          onClick={(event) => { this.clickNew(event) } }
                          disabled={this.checkPermission("add_purchase_template")}>
                          <em className="fa fa-plus" /><Translate value="create" />
                      </Button>
                      <Button
                          bsStyle="warning"
                          type="button"
                          onClick={(event) => { this.setCurrentPurchaseTemplate(event) } }
                          disabled={!this.state.selectedRows || this.state.selectedRows.length != 1}>
                          <em className="fa fa-pencil" />
                          <Translate value="edit" />
                      </Button>
                      <Button
                          bsStyle="danger"
                          type="reset"
                          onClick={(event) => { this.deleteCurrentPurchaseTemplate(event) } }
                          disabled={!this.state.selectedRows || this.state.selectedRows.length != 1}>
                          <em className="fa fa-trash-o" /><Translate value="delete" />
                      </Button>
                    </ButtonToolbar>
                    {this.renderTable() }
                    </Panel>
                  </Col>
                </Row>

                <Row>
                  <Col xs={ 12 }>
                    <h2><Translate value="purchase_template_details" /></h2>
                    <Panel className="details-table-collapse-fix">
                      {this.renderProductsTable() }
                    </Panel>
                  </Col>
                </Row>
              </Grid>
            </ContentWrapper>
        );
    }
}



export default PurchaseTemplateList;



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/purchaseTemplateList.jsx